/**
 * サムネイル付きスライダー
 * メインスライダーとサムネイルスライダーを同期
 * @see https://splidejs.com/tutorials/thumbnail-carousel/
 */

import "@splidejs/splide/dist/css/splide-core.min.css";
import { Splide } from "@splidejs/splide";


const mainElement = document.getElementById("js-splide-thumbnail-main");
const thumbnailsElement = document.getElementById("js-splide-thumbnail-nav");

if (mainElement && thumbnailsElement) {
  const main = new Splide(mainElement, {
    type: "fade",
    pagination: false,
    arrows: false,
  });
  
  const thumbnails = new Splide(thumbnailsElement, {
    rewind: true,
    type: "loop",
    autoplay: true, // 自動再生
    speed: 1200, // スクロール速度
    perPage: 1,
    // isNavigation: true, // ナビゲーションとして機能させるにはこのコメントアウトを外す
    gap: "calc(24 / 16 * 1rem)",
    focus: "center",
    pagination: false,
    // arrows: false,
    padding: "calc(160 / 16 * 1rem)",
    breakpoints: {
      768: {
        gap: "calc(10 / 16 * 1rem)",
        perPage: 1,
        padding: "calc(63 / 16 * 1rem)",
      },
    },
  });

  main.sync(thumbnails);
  main.mount();
  thumbnails.mount();
}


